import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as runReducer from "containers/Run/reducer";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import BYOMModal from "components/UnifiedProject/SelectData/BYOMModal";

class BYOMModalContainer extends React.Component {
  render() {
    return <BYOMModal {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateIsOpen: (isOpen) => dispatch(setupReducer.updateIsBYOMModal(ownProps.id, isOpen)),
    updateBYOM: (BYOM) => dispatch(setupReducer.updateBYOM(ownProps.id, BYOM))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;

  const isEditBlueprint = unifiedProjectReducer.getIsEditBlueprint(state, id);

  const innerRunId = projectReducer.getInnerId(state, id);
  const runId = innerRunId !== undefined ? innerRunId : isEditBlueprint ? "editBlueprint" : id;

  return {
    isOpen: setupReducer.getIsBYOMModal(state, ownProps.id),
    expectedExternalModel: runReducer.getExpectedExternalModel(state, runId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(BYOMModalContainer);
